export default from './category-list-masonry';



// WEBPACK FOOTER //
// ./app/components/category-list-masonry/index.js